import type { Invitation } from '@core/livestream/types'

export interface LivestreamGiveawayState {
  entered: boolean
  winnerRevealed?: boolean
  dismissed?: boolean
}
export type LivestreamGiveaways = Record<
  string,
  Record<string, LivestreamGiveawayState>
>
export interface ILiveStreamState {
  heartbeatInterval?: ReturnType<typeof setInterval>
  joinedTopics: string[]
  invitationsTokensDismissed: Record<string, Record<string, true>>
  invitations: Record<string, Invitation>
  username: IChannelUsername
  usernameHydrated?: IChannelUsername
  activeWatches: Record<string, boolean>
  liveStreamGiveaways: LivestreamGiveaways
}

export interface IChannelUsername {
  name: string
  isUserDefined: boolean
}

/**
 * Global state for live stream
 */
export function createLiveStreamState(): ILiveStreamState {
  return {
    heartbeatInterval: undefined,
    joinedTopics: [],
    invitationsTokensDismissed: {},
    invitations: {},
    username: { name: '', isUserDefined: false },
    activeWatches: {},
    liveStreamGiveaways: {},
  }
}
